import { render, staticRenderFns } from "./DepartSelect.vue?vue&type=template&id=bb47605c&scoped=true"
import script from "./DepartSelect.vue?vue&type=script&lang=js"
export * from "./DepartSelect.vue?vue&type=script&lang=js"
import style0 from "./DepartSelect.vue?vue&type=style&index=0&id=bb47605c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb47605c",
  null
  
)

export default component.exports